/*
*
* File JS componente BLOCK HP GALLERY
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-hp-gallery.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const initSwiper = () => {
    let elSwiperMagazine = document.querySelector('.block-hp-gallery .swiper-container');

    if(!elSwiperMagazine) return;

    Swiper.use([Navigation, Pagination]);

    const args = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 600,
        centeredSlides: true,
        loop: true,
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };
    
    let swiperMag = new Swiper(elSwiperMagazine, args);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockHpGallery = () => {

    initSwiper();

}

export default blockHpGallery;

//--------------------------------------------------------------------//